import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const SitemapIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M15.5 11H13.75V8C13.75 7.58594 13.4141 7.25 13 7.25H8.75V5H10.3154C10.6935 5 11 4.69348 11 4.31531V0.68463C11 0.30652 10.6935 0 10.3154 0H5.68463C5.30652 0 5 0.30652 5 0.68463V4.31531C5 4.69348 5.30652 5 5.68463 5H7.25V7.25H3C2.58594 7.25 2.25 7.58594 2.25 8V11H0.5C0.22388 11 0 11.2238 0 11.5V15.5C0 15.7761 0.22388 16 0.5 16H5.5C5.77612 16 6 15.7761 6 15.5V11.5C6 11.2238 5.77612 11 5.5 11H3.75V8.75H12.25V11H10.5C10.2239 11 10 11.2238 10 11.5V15.5C10 15.7761 10.2239 16 10.5 16H15.5C15.7761 16 16 15.7761 16 15.5V11.5C16 11.2238 15.7761 11 15.5 11Z" })));
};

export { SitemapIcon };
//# sourceMappingURL=SitemapIcon.esm.js.map
